<h1>Add New Document</h1>

<div class="tabs__control">
  <ul class="inline-list">

    <li>
      <button *ngIf="stepper.selectedIndex !== SELECTED_TAB.Upload" mat-raised-button color="accent"
        (click)="stepper.previous()">
        Back
      </button>
    </li>
    <li>
      <button *ngIf="stepper.selectedIndex < stepper?.steps?.length -1 " mat-raised-button color="primary"
        (click)="step(stepper);stepper.next()">
        Next
      </button>
    </li>
    <li>
      <button mat-raised-button color="accent" (click)="clear()"
        [routerLink]="['/',(folderID$ | async).objectStore,'browse',(folderID$ | async).id]">
        Cancel
      </button>
    </li>
  </ul>
</div>

<mat-horizontal-stepper [linear]="true" #stepper class="tabs__section">

  <mat-step class="myMatTab" [stepControl]="{ valid: !!(upload.file | async), invalid: !(upload.file | async) }">
    <ng-template matStepLabel>Select Document</ng-template>
    <mat-card class=" mat-card-sub">
      <app-document-upload-select #upload [folder]="folder$ | async">
      </app-document-upload-select>
    </mat-card>
  </mat-step>

  <mat-step class="myMatTab" [stepControl]="{ valid: properties.isValid, invalid: !properties.isValid }">
    <ng-template matStepLabel>Document Properties</ng-template>
    <mat-card class=" mat-card-sub">
      <document-properties-edit #properties [addMode]="true" [(ngModel)]="document"
        [objectStore]="(folderID$ | async)?.objectStore" [folder]="folder$ | async"
        [masterDataRequired]="(folder$ | async)?.propertiesObj.FolderMasterDataRequired"
        (ngModelChange)="changed($event)">
      </document-properties-edit>
    </mat-card>
  </mat-step>

  <mat-step *ngIf="(duplicates$ | async)?.length > 0" class="myMatTab"
    [stepControl]="{ valid: !!document.propertiesObj.ContractAcceptDuplicates, invalid: !document.propertiesObj.ContractAcceptDuplicates }">
    <ng-template matStepLabel>Duplicate Document</ng-template>
    <mat-card class=" mat-card-sub">
      <app-duplicate-check [documents]="duplicates$ | async" name="ContractAcceptDuplicates"
        [(ngModel)]="document.propertiesObj.ContractAcceptDuplicates"></app-duplicate-check>
    </mat-card>
  </mat-step>

  <mat-step class="myMatTab" [stepControl]="{ valid: true, invalid: false }">
    <ng-template matStepLabel>Comments</ng-template>
    <mat-card class=" mat-card-sub">
      <div class="form-container">
        <mat-form-field appearance="outline">
          <mat-label>Comments</mat-label>
          <input #Comments="ngModel" name="Comments" matInput
            [(ngModel)]="document.annotations[0].propertiesObj.AnnotationText"
            (change)="document.propertiesObj.FinalizeConsideredComments = document?.annotations[0]?.propertiesObj?.AnnotationText?.length > 0" />
        </mat-form-field>
      </div>
    </mat-card>
  </mat-step>



  <mat-step class="myMatTab"
    [stepControl]="{ valid: !(linkedDocumentRequired() && !(document?.linkedDocuments?.length>0)), invalid: (linkedDocumentRequired() && !(document?.linkedDocuments?.length>0)) }">
    <ng-template matStepLabel>Linked Documents</ng-template>
    <mat-card class=" mat-card-sub">
      <div class="alert alert-warning" *ngIf="linkedDocumentRequired() && !(document?.linkedDocuments?.length>0) ">At
        least one
        linked document is required</div>
      <app-linked-documents-view [addButton]="true" name="linkedDocuments" [(ngModel)]="document.linkedDocuments"
        [folderID]="(folderID$ | async)?.id" [objectStore]="(folderID$ | async)?.objectStore"
        (ngModelChange)="document.propertiesObj.FinalizeLinkedDocuments = document?.linkedDocuments?.length > 0">
      </app-linked-documents-view>
    </mat-card>
  </mat-step>

  <mat-step class="myMatTab" [stepControl]="{ valid: true, invalid: false }">
    <ng-template matStepLabel>Event Notifications</ng-template>
    <mat-card class=" mat-card-sub">
      <app-event-notification-view [(ngModel)]="document.alerts" [addButton]="true"
        (ngModelChange)="document.propertiesObj.FinalizeEventNotifications = document?.alerts?.length > 0">
      </app-event-notification-view>
    </mat-card>
  </mat-step>

  <mat-step class="myMatTab">
    <ng-template matStepLabel>Finalize</ng-template>
    <mat-card class=" mat-card-sub">
      I confirm that all the information provided is correct
      <section class="custom-check-box-group">
        <mat-checkbox class="custom-check-box" name="FinalizeConsideredComments"
          [(ngModel)]="document.propertiesObj.FinalizeConsideredComments">
          I have considered COMMENTS
        </mat-checkbox>
        <mat-checkbox class="custom-check-box" name="FinalizeLinkedDocuments"
          [(ngModel)]="document.propertiesObj.FinalizeLinkedDocuments">
          I have considered LINKED DOCUMENTS
        </mat-checkbox>

        <mat-checkbox class="custom-check-box" name="FinalizeEventNotifications"
          [(ngModel)]="document.propertiesObj.FinalizeEventNotifications">
          I have considered EVENT NOTIFICATIONS
        </mat-checkbox>

        <mat-checkbox class="custom-check-box" name="FinalizeSignedByAll"
          [(ngModel)]="document.propertiesObj.FinalizeSignedByAll">
          The contract has been signed by all parties
        </mat-checkbox>

      </section>

      <mat-spinner *ngIf="busyUploading"></mat-spinner>

      <ul class="table__control inline-list" *ngIf="!busyUploading">

        <li>
          <button [disabled]="linkedDocumentRequired() && !(document?.linkedDocuments?.length>0) || !(document.propertiesObj.FinalizeConsideredComments &&
            document.propertiesObj.FinalizeLinkedDocuments && document.propertiesObj.FinalizeEventNotifications &&
            document.propertiesObj.FinalizeSignedByAll)" mat-raised-button color="primary" (click)="save()">
            Save
          </button>
        </li>
      </ul>
      <div class="alert alert-warning" *ngIf="uploadFailed">Upload failed,
        please contact Support</div>
    </mat-card>
  </mat-step>
</mat-horizontal-stepper>
<!-- {{document | json}} -->
